export default "__VITE_ASSET__DLDdNBjX__"